var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M47 40a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V11a4 4 0 0 1 4-4h20.171l8.099-2.934a.99.99 0 0 1 1.268.589L35.391 7H39a4 4 0 0 1 4 4v2a4 4 0 0 1 4 4v23zM5 9a2 2 0 0 0 0 4h3.634c.013-.005.021-.016.034-.021L19.65 9H5zm29.078.181-1.062-2.924h-.001L30.964 7h.003l-5.514 2h-.01l-11.039 4h21.062l-1.388-3.819zM41 11a2 2 0 0 0-2-2h-2.883l1.454 4H41v-2zm2 4H5c-.732 0-1.41-.211-2-.555V40a3 3 0 0 0 3 3h36a3 3 0 0 0 3-3v-7h-4a4 4 0 0 1 0-8h4v-8a2 2 0 0 0-2-2zm2 16v-4h-4a2 2 0 0 0 0 4h4zm-4-3h2v2h-2v-2z",
    fillRule: "evenodd",
    fill: "#ff7b26",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.0e2b184ce16479ce3d8ccf93c7ce4b8f.svg";
export { ForwardRef as ReactComponent };